module.exports = __webpack_public_path__ + "img/logs-icon.b39607d5.svg";